var PluralType;
(function (PluralType) {
  PluralType["SINGULAR"] = "singular";
  PluralType["PLURAL"] = "plural";
  PluralType["FEW"] = "few";
  PluralType["TWO"] = "two";
  PluralType["TRIPLE"] = "triple";
  PluralType["ZERO"] = "zero";
  PluralType["MANY"] = "many";
})(PluralType || (PluralType = {}));
var SINGULAR = PluralType.SINGULAR;
var PLURAL = PluralType.PLURAL;
var FEW = PluralType.FEW;
var TWO = PluralType.TWO;
PluralType.TRIPLE;
var ZERO = PluralType.ZERO;
var MANY = PluralType.MANY;

// generic.js
var generic = function generic(number) {
  return number === 1 ? SINGULAR : PLURAL;
};

// ru.js
// eslint-disable-next-line complexity
var russian = function russian(number) {
  if (number % 1 !== 0) {
    return PLURAL;
  }
  if (number >= 100) {
    number %= 100; // eslint-disable-line no-param-reassign
  }
  var digit = number % 10;
  if (digit === 0 || digit >= 5 || number >= 10 && number <= 14) {
    return MANY;
  }
  if (digit === 1) {
    return SINGULAR;
  }
  if (number < 10) {
    return TWO;
  }
  return FEW;
};

// slv.js
var FractionalPart = /** @class */function () {
  function FractionalPart() {}
  FractionalPart.getFractionalPart = function (number) {
    var string = number.toString();
    if (!String(number).includes('.')) {
      return 0;
    }
    return Number(string.split('.')[1]);
  };
  return FractionalPart;
}();
// eslint-disable-next-line complexity
function southslavic(number) {
  if (number % 1 !== 0) {
    number = FractionalPart.getFractionalPart(number); // eslint-disable-line no-param-reassign
  }
  var number100 = number % 100;
  var number10 = number % 10;
  if (number10 === 1 && number100 !== 11) {
    return SINGULAR;
  }
  if (number10 >= 2 && number10 <= 4 && (number100 < 12 || number100 > 14)) {
    return FEW;
  }
  return PLURAL;
}

// pl.js
var polish = function polish(number) {
  if (number % 1 !== 0) {
    return PLURAL;
  }
  if (number === 1) {
    return SINGULAR;
  }
  var number100 = number % 100;
  var number10 = number % 10;
  if (number10 >= 2 && number10 <= 4 && (number100 < 12 || number100 > 14)) {
    return FEW;
  }
  return MANY;
};

// he.js
var hebrew = function hebrew(number) {
  if (number % 1 !== 0) {
    return PLURAL;
  }
  if (number === 1) {
    return SINGULAR;
  }
  if (number === 2) {
    return TWO;
  }
  if (number > 10 && number % 10 === 0) {
    return MANY;
  }
  return PLURAL;
};

// sk.js
var czechoslovak = function czechoslovak(number) {
  if (number % 1 !== 0) {
    return MANY;
  }
  if (number === 1) {
    return SINGULAR;
  }
  if (number >= 2 && number <= 4) {
    return FEW;
  }
  return PLURAL;
};

// ar.js
// eslint-disable-next-line complexity
var arabic = function arabic(number) {
  if (number % 1 !== 0) {
    return PLURAL;
  }
  if (number === 0) {
    return ZERO;
  }
  if (number === 1) {
    return SINGULAR;
  }
  if (number === 2) {
    return TWO;
  }
  var num100 = number % 100;
  if (num100 >= 3 && num100 <= 10) {
    return FEW;
  }
  if (num100 >= 11 && num100 <= 99) {
    return MANY;
  }
  return PLURAL;
};

// sl.js
var slovenian = function slovenian(number) {
  if (number % 1) {
    return FEW;
  }
  number %= 100; // eslint-disable-line no-param-reassign
  if (number === 1) {
    return SINGULAR;
  }
  if (number === 2) {
    return TWO;
  }
  if (number === 3 || number === 4) {
    return FEW;
  }
  return PLURAL;
};

// lt.js
var lithuanian = function lithuanian(number) {
  if (number % 1 !== 0) {
    return MANY;
  }
  var number100 = number % 100;
  var number10 = number % 10;
  if (number100 < 11 || number100 > 19) {
    if (number10 === 1) {
      return SINGULAR;
    }
    if (number10 >= 2 && number10 <= 9) {
      return FEW;
    }
  }
  return PLURAL;
};

// fr.js
var simpleLang = function simpleLang(number) {
  if (number === 1 || number === 0) {
    return SINGULAR;
  }
  return PLURAL;
};

// is.js
var islandic = function islandic(number) {
  if (number % 10 === 1 && number % 100 !== 11 || number * 10 % 10 !== 0) {
    return SINGULAR;
  }
  return PLURAL;
};

// ro.js
var romanian = function romanian(number) {
  if (number === 1) {
    return SINGULAR;
  }
  var hundredth = number % 100;
  if (number === 0 || number * 10 % 10 !== 0 || hundredth >= 1 && hundredth <= 19) {
    return FEW;
  }
  return PLURAL;
};

// lv.js
var latvian = function latvian(number) {
  var fractional = Number(number.toString().split('.')[1]);
  var number100 = number % 100;
  var number10 = number % 10;
  if (!fractional && (number10 === 0 || number100 >= 11 && number100 <= 19)) {
    return ZERO;
  }
  if (number10 === 1 || fractional === 1) {
    return SINGULAR;
  }
  return PLURAL;
};

// uk.js
// eslint-disable-next-line complexity
var ukranian = function ukranian(number) {
  if (number % 1 !== 0) {
    return PLURAL;
  }
  if (number >= 100) {
    number = number % 100; // eslint-disable-line no-param-reassign
  }
  var lastDigit = number % 10;
  if (lastDigit === 0 || lastDigit >= 5 || number >= 10 && number <= 14) {
    return MANY;
  }
  if (lastDigit === 1) {
    return SINGULAR;
  }
  return FEW;
};

/* eslint-disable object-shorthand */
var RULES = {
  bn: simpleLang,
  hi: simpleLang,
  fr: simpleLang,
  'pt-br': simpleLang,
  is: islandic,
  ro: romanian,
  ru: russian,
  hr: southslavic,
  sr: southslavic,
  slv: southslavic,
  bs: czechoslovak,
  pl: polish,
  he: hebrew,
  sk: czechoslovak,
  cs: czechoslovak,
  sl: slovenian,
  ar: arabic,
  lt: lithuanian,
  lv: latvian,
  uk: ukranian
};
/* eslint-enable object-shorthand */
function getRule(lang) {
  if (lang && RULES[lang]) {
    return RULES[lang];
  }
  return generic;
}
function getCountedForm(lang, number) {
  var rule = getRule(lang);
  return rule(number);
}
function getDefaultCountedForm() {
  return PLURAL;
}
var index = {
  getCountedForm: getCountedForm,
  getDefaultCountedForm: getDefaultCountedForm
};

export { index as default, getCountedForm, getDefaultCountedForm };
